import { useAnchorClickMessageDispatcher } from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/loggers';
import { source } from './dispatchers/constants';
import useFullscreenDispatcher from './dispatchers/useFullscreenDispatcher';
import useModalMessageDispatcher from './dispatchers/useModalMessageDispatcher';
import usePageReadyDispatcher from './dispatchers/usePageReadyDispatcher';

/**
 * This hook dispatches messages to the native app.
 */

export default function useNativeMessageDispatcher() {
  useAnchorClickMessageDispatcher({
    logError,
    source,
    verboseLogs: isNonProd
  });
  useFullscreenDispatcher();
  useModalMessageDispatcher();
  usePageReadyDispatcher();
}
